export default __webpack_public_path__ + "a5d06b2b4e1c3b36fe4a7be549ea5a20.png";